export type HomeGame = {
  id: number;
  title: string;
  providerId: string;
  providerName: string;
  imageUrl: string;
  code?: string;
  filters?: string[];
  [key: string]: unknown;
};

export type HomeGamesResponse = {
  bonus?: HomeGame[];
  preferred?: HomeGame[];
  recommended?: HomeGame[];
  popular?: HomeGame[];
  totalGamesCount?: number;
};

export const HOME_GAME_SECTION_IDS = [
  'bonus',
  'preferred',
  'recommended',
  'popular',
] as const;
